import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "bootstrap-daterangepicker";
import moment from "moment";

const DaterangePicker = ({ onDateChange, className }) => {
  const pickerRef = useRef();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Only initialize once
    if (isInitialized) return;

    const initializePicker = () => {
      if (!pickerRef.current) return;

      // Destroy any existing picker
      try {
        $(pickerRef.current).daterangepicker("destroy");
      } catch (e) {
        // Ignore errors if picker doesn't exist
      }

      // Initialize the date range picker
      $(pickerRef.current).daterangepicker({
        autoUpdateInput: false,
        locale: {
          cancelLabel: "Clear",
          format: "MM/DD/YYYY",
        },
        startDate: moment().startOf("day"),
        endDate: moment().endOf("day"),
      });

      // Handle apply event
      $(pickerRef.current).on("apply.daterangepicker", function (ev, picker) {
        try {
          const start = picker.startDate.format("YYYY-MM-DD");
          const end = picker.endDate.format("YYYY-MM-DD");
          const displayStart = picker.startDate.format("MM/DD/YYYY");
          const displayEnd = picker.endDate.format("MM/DD/YYYY");

          $(this).val(displayStart + " - " + displayEnd);

          // Call onDateChange with ISO format dates
          if (onDateChange) {
            onDateChange({
              start: start,
              end: end,
            });
          }
        } catch (error) {
          console.error("Error in date picker apply:", error);
        }
      });

      // Handle cancel event
      $(pickerRef.current).on("cancel.daterangepicker", function (ev, picker) {
        // Clear the input field
        $(this).val("");

        // Reset the picker dates to current date
        picker.setStartDate(moment().startOf("day"));
        picker.setEndDate(moment().endOf("day"));

        // Call onDateChange with empty values when cleared
        if (onDateChange) {
          onDateChange({ start: "", end: "" });
        }
      });

      setIsInitialized(true);
    };

    // Initialize with a small delay to ensure DOM is ready
    const timer = setTimeout(initializePicker, 100);

    // Cleanup function
    return () => {
      clearTimeout(timer);
      if (pickerRef.current && isInitialized) {
        try {
          $(pickerRef.current).daterangepicker("destroy");
          $(pickerRef.current).off("apply.daterangepicker");
          $(pickerRef.current).off("cancel.daterangepicker");
        } catch (e) {
          // Ignore cleanup errors
        }
      }
    };
  }, [onDateChange, isInitialized]);

  return (
    <div>
      <input
        type="text"
        ref={pickerRef}
        style={{ width: "100%", padding: "10px", fontSize: "16px" }}
        placeholder="Select date range"
        name="datefilter"
        className={className}
        readOnly
      />
    </div>
  );
};

export default DaterangePicker;
